import React from 'react';
import { connect } from 'react-redux';
import BackgroundImageComponent from './background-image.component';

class BackgroundAndToolsContainer extends React.Component {
  render() {
    const {
      lang,
      content
    } = this.props;

    return (
      <React.Fragment>
        <BackgroundImageComponent
          lang={lang}
          content={content}
        />
      </React.Fragment>
    );
  }
}

/* the container to component mapping */
const mapStateToProps = (state) => {
  return {
    lang: state.localization.lang,
    content: state.localization.content,
  };
};

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BackgroundAndToolsContainer);



// WEBPACK FOOTER //
// ./src/components/LeftMenu/BackgroundImage/backgroundAndTools.container.js